<template>
    <div :style="'backgroundImage: url(' + imageUrl + ')'" class="img-container animated" :class="{'fadeIn':finished}">
        <i class="iconfont icon-jiazai" v-if="!finished"></i>
    </div>
</template>

<script>
    export default {
        name: "i-image",
        props: {
            src: {
                type: String,
                default: '',
            },
            loading: {
                type: Boolean,
                default: true,
            },
            defaultSrc: {
                type: String,
                default: '',
            }
        },
        data() {
            return {
                style: {},
                finished: false,
                imageUrl: ""
            }
        },
        methods: {
            genClass: function () {
                let image = new Image();
                image.src = this.src;
                let _self = this;
                image.onload = function () {
                    _self.finished = true;
                    _self.imageUrl = _self.src;
                };
            },
            initPic:function () {
                this.genClass();
                this.imageUrl = this.defaultSrc;
            }
        },
        created: function () {
            this.initPic();
        },
        watch:{
            src:function () {
                this.initPic();
            }
        }
    }
</script>

<style scoped lang="less">
    .img-container {
        background: no-repeat center center #f5f5f5;
        background-size: cover;
        text-align: center;
        position: relative;
        i {
            color: #919191;
            animation: loading 1s infinite linear;
            position: absolute;
            left: 0;
            right: 0;
            top: 40%;
        }
    }

    @keyframes loading {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
</style>